import { MaterialType } from '../../../types/material-page';
import { ChildElementType, OverlayTrigger } from '../../../ui/overlay-trigger/overlay-trigger';
import Tooltip from '../../../ui/tooltip';
import { MATERIAL_LABELS, MaterialLabelName } from '../../../utils/material/material-labels.constants';
import discountPercent from '../../../utils/sale/discount-percent';
import MaterialLabel from '../../material-label/material-label';
import QualityBadge from '../../quality-badge/quality-badge';
import { MATERIAL_LABEL_TOOLTIP_KEYS } from './material-labels.constants';

type RenderMaterialLabelProps = {
    name: MaterialLabelName;
    item: Material;
    hasTooltip: boolean;
    t: TranslationProps['t'];
};

// Renders one label; each label decides how it shows its tooltip
export const renderMaterialLabel = ({ name, item, hasTooltip, t }: RenderMaterialLabelProps): ChildElementType => {
    const tooltipKey = MATERIAL_LABEL_TOOLTIP_KEYS[name];
    const tooltip = hasTooltip && tooltipKey ? t(tooltipKey) : '';

    const withTooltip = (label: ChildElementType): ChildElementType =>
        tooltip ? (
            <OverlayTrigger
                rootClose
                overlay={<Tooltip.Simple id={`label-${name}`}>{tooltip}</Tooltip.Simple>}
                placement='bottom'
                trigger={['click', 'hover']}
            >
                {label}
            </OverlayTrigger>
        ) : (
            label
        );

    const labelByName: Record<MaterialLabelName, () => ChildElementType> = {
        [MATERIAL_LABELS.DONATE]: () =>
            withTooltip(
                <div className='donate label'>
                    {t('common.label.donate')}
                    <div className='triangle' />
                </div>
            ),
        [MATERIAL_LABELS.SALE]: () =>
            withTooltip(
                <MaterialLabel variant='red'>
                    −{discountPercent(Number(item.sale?.original_price), item.price)}%
                </MaterialLabel>
            ),
        [MATERIAL_LABELS.BESTSELLER]: () => withTooltip(<MaterialLabel variant='yellow'>Bestseller</MaterialLabel>),
        // The quality label brings its own tooltip, with a link to the quality page
        [MATERIAL_LABELS.HIGH_QUALITY]: () => (
            <QualityBadge noIcon={!hasTooltip} noTooltip={!hasTooltip} material={item as MaterialType} />
        ),
        [MATERIAL_LABELS.NEW]: () => withTooltip(<MaterialLabel variant='cyan'>{t('common.label.new')}</MaterialLabel>)
    };

    return labelByName[name]();
};
